import { render } from "./AppInfo.vue?vue&type=template&id=263b127c&scoped=true&ts=true"
import script from "./AppInfo.vue?vue&type=script&lang=ts"
export * from "./AppInfo.vue?vue&type=script&lang=ts"

import "./AppInfo.vue?vue&type=style&index=0&id=263b127c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263b127c"]])

export default __exports__